declare global {
    let Swiper: any;
}

import {SwiperOptions} from 'swiper/types';

function partnerSlider() {
  
  let options: SwiperOptions = {
    slidesPerView  : 'auto',
    spaceBetween   : 9,
    grabCursor     : true,
    freeMode       : true,
    centeredSlides : false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      992: {
        centeredSlides : false,
        slidesPerView  : 2,
        spaceBetween   : 9,
      },
      1200: {
        centeredSlides : false,
        slidesPerView  : 3,
        spaceBetween   : 25,
      },
    },

  }

  let optionsT: SwiperOptions = {
    slidesPerView  : 1,
    grabCursor     : true,
    freeMode       : true,
    centeredSlides : true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  }

  let sliderPremium         = new Swiper('.premium-carousel'         , options);
  let sliderBusiness        = new Swiper('.business-carousel'        , options);
  let sliderEvents          = new Swiper('.events-carousel'          , options);
  let sliderStandardDesktop = new Swiper('.standard-carousel-desktop', options);
  let sliderStandardMobile  = new Swiper('.standard-carousel-mobile' , options);
  let sliderTestimonial     = new Swiper('.testimonials-carousel'    , optionsT);

}

partnerSlider();

